import * as React from 'react';
import './loader.css'
interface IAgencyCardLoaderProps {
}

export const AgencyCardLoader: React.SFC<IAgencyCardLoaderProps> = (props) => {
    return (
        <div className="animated-background border info-card cardloader" style={{ padding: 0 }}>
            <svg width="100%" height="100%" id="CardLoader">
                <defs>
                    <mask id="agencycardmask">
                        <rect width="100%" height="100%" fill="white" />
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="386px" height="184px" viewBox="0 0 3860 1840" preserveAspectRatio="xMidYMid meet">
                            <g id="layer101" fill="#2abcca" stroke="none">
                                <path d="M0 920 l0 -920 1930 0 1930 0 0 920 0 920 -1930 0 -1930 0 0 -920z" />
                            </g>
                            <g id="layer102" fill="#ffffff" stroke="none">
                                <path d="M0 920 l0 -920 1930 0 1930 0 0 920 0 920 -1930 0 -1930 0 0 -920z m3705 620 l0 -155 -595 0 -595 0 -3 145 c-1 79 0 150 2 157 4 11 118 13 598 11 l593 -3 0 -155z m-2375 -425 l0 -65 -180 0 -180 0 0 65 0 65 180 0 180 0 0 -65z m480 0 l0 -65 -200 0 -200 0 0 65 0 65 200 0 200 0 0 -65z m-480 -150 l0 -65 -180 0 -180 0 0 65 0 65 180 0 180 0 0 -65z m1350 0 l0 -65 -635 0 -635 0 0 65 0 65 635 0 635 0 0 -65z m-2065 -119 c79 -36 156 -112 191 -190 24 -52 28 -74 29 -151 0 -78 -4 -98 -28 -150 -37 -79 -114 -156 -191 -192 -53 -24 -73 -28 -151 -28 -80 0 -97 3 -155 31 -82 39 -144 101 -184 184 -28 58 -31 75 -31 155 0 80 4 97 31 155 69 144 199 223 354 217 56 -3 91 -10 135 -31z m885 -61 l0 -65 -265 0 -265 0 0 65 0 65 265 0 265 0 0 -65z m620 0 l0 -65 -275 0 -275 0 0 65 0 65 275 0 275 0 0 -65z m1120 -255 l0 -110 -287 0 c-159 0 -669 -3 -1135 -7 l-848 -6 0 111 0 112 568 3 c312 1 822 3 1135 5 l567 2 0 -110z m290 -290 l0 -110 -1280 0 -1280 0 0 110 0 110 1280 0 1280 0 0 -110z" />
                            </g>
                        </svg>
                    </mask>
                </defs>

                <rect id="back" width="100%" height="100%" fill="white" mask="url(#agencycardmask)" />
            </svg>
        </div>
    )
};